const getPortalIdOnWindow = targetWindow => {
  if (!targetWindow) {
    return undefined;
  }
  try {
    var _hubspot$portal, _pathRegex$exec;
    const {
      hubspot,
      document
    } = targetWindow;
    const portalIdCached = hubspot === null || hubspot === void 0 || (_hubspot$portal = hubspot.portal) === null || _hubspot$portal === void 0 ? void 0 : _hubspot$portal.id;
    if (portalIdCached) {
      return portalIdCached;
    }
    const pathRegex = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/;
    const portalId = (_pathRegex$exec = pathRegex.exec(document.location.pathname)) === null || _pathRegex$exec === void 0 ? void 0 : _pathRegex$exec[1];
    return portalId;
  } catch (_unused) {
    // Ignore error
  }
  return undefined;
};
export const getPortalId = () => {
  return getPortalIdOnWindow(window) || getPortalIdOnWindow(window.top);
};